/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Row_EvidenceInputs */

const en_cmp_row_evidence = /** @type {(inputs: Cmp_Row_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidence panel`)
};

const id_cmp_row_evidence = /** @type {(inputs: Cmp_Row_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel bukti`)
};

/**
* | output |
* | --- |
* | "Evidence panel" |
*
* @param {Cmp_Row_EvidenceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_row_evidence = /** @type {((inputs?: Cmp_Row_EvidenceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Row_EvidenceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_row_evidence(inputs)
	return en_cmp_row_evidence(inputs)
});